// src/utils/device.js
export default {
    install(Vue) {
        // 创建一个响应式对象，方便后续自动更新
        const state = Vue.observable({
            isMobile: false
        });

        function checkDevice() {
            const ua = navigator.userAgent;
            const uaMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
            const smallScreen = window.innerWidth <= 768;
            state.isMobile = uaMobile || smallScreen;
        }

        // 初始化和监听
        checkDevice();
        window.addEventListener("resize", checkDevice);

        // 将属性挂载到 Vue 原型上
        Object.defineProperty(Vue.prototype, "$isMobile", {
            get() {
                return state.isMobile;
            }
        });
    }
};
